import { createSlice } from '@reduxjs/toolkit';
import {query, describe} from '../../services/salesforce'

export const documentSlice = createSlice({

    // Slice name, this should be always as page name.
    name: 'document',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null
    },

    // Reducers will mutate the state, put all the state mutation method over here 
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
    },
})

export default documentSlice.reducer

// Export all the reducers actions here
export const { initialize, error } = documentSlice.actions;


// Public Selectors
export const selectDocumentData = (state) => state.document.data;
export const selectDocumentStatus = (state) => state.document.status;
export const selectDocumentError = (state) => state.document.error;

export const initializeAsync = (props) => async (dispatch) => {
    // const result = await query('account');
    // if(result.isSuccess){
    //     dispatch(initialize({records: result.data}));
    // }
    // else{
    //     dispatch(error(result.errorMessage))
    // }

    //dispatch(initialize({}));
}

